// extracted by mini-css-extract-plugin
module.exports = {"langWrapper":"styles_langWrapper__oaRQ4","langButton":"styles_langButton__UWpPC","langDropdown":"styles_langDropdown__1FxPM","visible":"styles_visible__FuT_H"};